const getUserGroups = (user: any) => {
    if (user) {
        const signInSession = user.getSignInUserSession();

        if (signInSession) {
            const accessToken = signInSession.getAccessToken();

            if (accessToken) {
                if (!accessToken.payload.hasOwnProperty("cognito:groups")) {
                    return [];
                }
                return accessToken.payload["cognito:groups"];
            }

        }
    }
    return [];
}

export const checkIfIdUser = (user: any): boolean => {
    const userGroups = getUserGroups(user);

    return userGroups.includes(process.env.REACT_APP_FLEET_APP_GROUP);
}


export const getUserHasAccess = (user: any): boolean => {
    const userGroups = getUserGroups(user);

    return Boolean(
        userGroups.includes(process.env.REACT_APP_FLEET_APP_GROUP) ||
        userGroups.includes(process.env.REACT_APP_IDWAL_ADMINISTRATORS_GROUP)) ||
        userGroups.includes('FleetTechnicalManager');
}
